import { render, staticRenderFns } from "./ListJobNew.vue?vue&type=template&id=2ed95b33"
import script from "./ListJobNew.vue?vue&type=script&lang=js"
export * from "./ListJobNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports